import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Hausverwaltung {
  id: string;
  uuid: string;
  name: string;
  normalized_key?: string;
  strasse?: string;
  plz?: string;
  ort?: string;
  land?: string;
  zuhanden?: string;
  uid?: string;
  email?: string;
  telefon?: string;
  anmerkungen?: string;
  status_id?: number;
  created_at?: string;
  updated_at?: string;

  // Derived (list + detail)
  kunden_count?: number;
  standorte_count?: number;

  // Detail-only relations
  kunden?: HausverwaltungKunde[];
  standorte?: HausverwaltungStandort[];
  rechnungsvertraege?: any[];
  kontakte?: any[];
}

export interface HausverwaltungKunde {
  id: string;
  uuid: string;
  suchbegriff: string;
  alte_kundennummer?: string;
  ort?: string;
  status_id?: number;
}

export interface HausverwaltungStandort {
  id: string;
  name: string;
  strasse?: string;
  plz?: string;
  ort?: string;
  status?: number;
  kunde_name?: string;
}

export interface HausverwaltungListResponse {
  result: number;
  data: Hausverwaltung[];
  total?: number;
  page?: number;
  limit?: number;
  error?: string;
  sec: string;
}

export interface HausverwaltungSingleResponse {
  result: number;
  data: Hausverwaltung;
  error?: string;
  sec: string;
}

@Injectable({ providedIn: 'root' })
export class HausverwaltungService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getHausverwaltungen(
    page: number = 1,
    limit: number = 25,
    search: string = '',
    sortBy: string = 'name',
    sortOrder: string = 'asc',
    prefix?: string
  ): Observable<HausverwaltungListResponse> {
    const params: any = {
      page: page.toString(),
      limit: limit.toString(),
      search,
      sortBy,
      sortOrder,
    };
    if (prefix) {
      params.prefix = prefix;
    }
    return this.http.get<HausverwaltungListResponse>(`${this.apiUrl}/hausverwaltung`, { params });
  }

  getHausverwaltung(id: string): Observable<HausverwaltungSingleResponse> {
    return this.http.get<HausverwaltungSingleResponse>(`${this.apiUrl}/hausverwaltung/${id}`);
  }

  createHausverwaltung(hv: Partial<Hausverwaltung>): Observable<HausverwaltungSingleResponse> {
    return this.http.post<HausverwaltungSingleResponse>(`${this.apiUrl}/hausverwaltung`, hv);
  }

  updateHausverwaltung(id: string, hv: Partial<Hausverwaltung>): Observable<HausverwaltungSingleResponse> {
    return this.http.put<HausverwaltungSingleResponse>(`${this.apiUrl}/hausverwaltung/${id}`, hv);
  }

  deleteHausverwaltung(id: string): Observable<HausverwaltungSingleResponse> {
    return this.http.delete<HausverwaltungSingleResponse>(`${this.apiUrl}/hausverwaltung/${id}`);
  }
}
